import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0760 = React.lazy(() => import('./symbols/0760_weather_sun_summer'));
const Symbol0761 = React.lazy(() => import('./symbols/0761_weather_cloud'));
const Symbol0762 = React.lazy(() => import('./symbols/0762_weather_rain_cloud'));
const Symbol0763 = React.lazy(() => import('./symbols/0763_weather_moon_stars_night_sleep'));
const Symbol0764 = React.lazy(() => import('./symbols/0764_weather_rain_water_drop'));
const Symbol0765 = React.lazy(() => import('./symbols/0765_weather_rain_umbrella'));
const Symbol0766 = React.lazy(() => import('./symbols/0766_weather_snow_flake_winter'));
const Symbol0767 = React.lazy(() => import('./symbols/0767_weather_wind'));
const Symbol0768 = React.lazy(() => import('./symbols/0768_weather_tornado_typhoon_wind'));
const Symbol0769 = React.lazy(() => import('./symbols/0769_weather_cloud_sun'));
const Symbol0770 = React.lazy(() => import('./symbols/0770_park_bench_rest_tree_forest'));
const Symbol0771 = React.lazy(() => import('./symbols/0771_park_tree_forest'));
const Symbol0772 = React.lazy(() => import('./symbols/0772_park_tree_forest'));
const Symbol0773 = React.lazy(() => import('./symbols/0773_flower'));
const Symbol0774 = React.lazy(() => import('./symbols/0774_maple_leaf_canada_tree'));
const Symbol0775 = React.lazy(() => import('./symbols/0775_leaf_nature_bio_green'));
const Symbol0776 = React.lazy(() => import('./symbols/0776_camping_cooking_outside_fireplace'));
const Symbol0777 = React.lazy(() => import('./symbols/0777_camping_fire_fireplace'));
const Symbol0778 = React.lazy(() => import('./symbols/0778_fire_fireplace'));
const Symbol0779 = React.lazy(() => import('./symbols/0779_wood_ax'));
const Symbol0780 = React.lazy(() => import('./symbols/0780_camping_tent'));
const Symbol0781 = React.lazy(() => import('./symbols/0781_camping_director_fisherman_chair'));
const Symbol0782 = React.lazy(() => import('./symbols/0782_lighter_fire_zippo'));
const Symbol0783 = React.lazy(() => import('./symbols/0783_swiss_army_knife_camping'));
const Symbol0784 = React.lazy(() => import('./symbols/0784_army_knife_jungle'));
const Symbol0785 = React.lazy(() => import('./symbols/0785_mountains_nature'));
const Symbol0786 = React.lazy(() => import('./symbols/0786_basecamp_alps_mountains_cabin'));
const Symbol0787 = React.lazy(() => import('./symbols/0787_mountains_nature'));
const Symbol0788 = React.lazy(() => import('./symbols/0788_gondola_lift_mountains'));
const Symbol0789 = React.lazy(() => import('./symbols/0789_mountaineering'));
const Symbol0790 = React.lazy(() => import('./symbols/0790_acorn_forest_fruit'));
const Symbol0791 = React.lazy(() => import('./symbols/0791_mushroom_forest_fruit'));
const Symbol0792 = React.lazy(() => import('./symbols/0792_archery_bow'));
const Symbol0793 = React.lazy(() => import('./symbols/0793_archery_bow'));
const Symbol0794 = React.lazy(() => import('./symbols/0794_horseshoe_luck'));
const Symbol0795 = React.lazy(() => import('./symbols/0795_canoeing_rowing_wild_river'));
const Symbol0796 = React.lazy(() => import('./symbols/0796_nature_green_sprout_plant'));
const Symbol0797 = React.lazy(() => import('./symbols/0797_flowers_plant'));
const Symbol0798 = React.lazy(() => import('./symbols/0798_leaf_tree_forest'));
const Symbol0799 = React.lazy(() => import('./symbols/0799_leaf_tree_forest'));
const Symbol0800 = React.lazy(() => import('./symbols/0800_leaf_plant_sprout_green'));
const Symbol0801 = React.lazy(() => import('./symbols/0801_shovel_ground'));
const Symbol0802 = React.lazy(() => import('./symbols/0802_plant_watering'));
const Symbol0803 = React.lazy(() => import('./symbols/0803_wheelbarrow_farming'));
const Symbol0804 = React.lazy(() => import('./symbols/0804_wheelbarrow_full'));
const Symbol0805 = React.lazy(() => import('./symbols/0805_tractor_farming'));
const Symbol0806 = React.lazy(() => import('./symbols/0806_gate_farm'));
const Symbol0807 = React.lazy(() => import('./symbols/0807_bees_honey'));
const Symbol0808 = React.lazy(() => import('./symbols/0808_bird_house_twitter'));
const Symbol0809 = React.lazy(() => import('./symbols/0809_snail_shell_house_nautilus'));

export interface IProps {}

const Nature: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0760_weather_sun_summer" symbol={<Symbol0760 />} />
      <LazySymbol id="0761_weather_cloud" symbol={<Symbol0761 />} />
      <LazySymbol id="0762_weather_rain_cloud" symbol={<Symbol0762 />} />
      <LazySymbol id="0763_weather_moon_stars_night_sleep" symbol={<Symbol0763 />} />
      <LazySymbol id="0764_weather_rain_water_drop" symbol={<Symbol0764 />} />
      <LazySymbol id="0765_weather_rain_umbrella" symbol={<Symbol0765 />} />
      <LazySymbol id="0766_weather_snow_flake_winter" symbol={<Symbol0766 />} />
      <LazySymbol id="0767_weather_wind" symbol={<Symbol0767 />} />
      <LazySymbol id="0768_weather_tornado_typhoon_wind" symbol={<Symbol0768 />} />
      <LazySymbol id="0769_weather_cloud_sun" symbol={<Symbol0769 />} />
      <LazySymbol id="0770_park_bench_rest_tree_forest" symbol={<Symbol0770 />} />
      <LazySymbol id="0771_park_tree_forest" symbol={<Symbol0771 />} />
      <LazySymbol id="0772_park_tree_forest" symbol={<Symbol0772 />} />
      <LazySymbol id="0773_flower" symbol={<Symbol0773 />} />
      <LazySymbol id="0774_maple_leaf_canada_tree" symbol={<Symbol0774 />} />
      <LazySymbol id="0775_leaf_nature_bio_green" symbol={<Symbol0775 />} />
      <LazySymbol id="0776_camping_cooking_outside_fireplace" symbol={<Symbol0776 />} />
      <LazySymbol id="0777_camping_fire_fireplace" symbol={<Symbol0777 />} />
      <LazySymbol id="0778_fire_fireplace" symbol={<Symbol0778 />} />
      <LazySymbol id="0779_wood_ax" symbol={<Symbol0779 />} />
      <LazySymbol id="0780_camping_tent" symbol={<Symbol0780 />} />
      <LazySymbol id="0781_camping_director_fisherman_chair" symbol={<Symbol0781 />} />
      <LazySymbol id="0782_lighter_fire_zippo" symbol={<Symbol0782 />} />
      <LazySymbol id="0783_swiss_army_knife_camping" symbol={<Symbol0783 />} />
      <LazySymbol id="0784_army_knife_jungle" symbol={<Symbol0784 />} />
      <LazySymbol id="0785_mountains_nature" symbol={<Symbol0785 />} />
      <LazySymbol id="0786_basecamp_alps_mountains_cabin" symbol={<Symbol0786 />} />
      <LazySymbol id="0787_mountains_nature" symbol={<Symbol0787 />} />
      <LazySymbol id="0788_gondola_lift_mountains" symbol={<Symbol0788 />} />
      <LazySymbol id="0789_mountaineering" symbol={<Symbol0789 />} />
      <LazySymbol id="0790_acorn_forest_fruit" symbol={<Symbol0790 />} />
      <LazySymbol id="0791_mushroom_forest_fruit" symbol={<Symbol0791 />} />
      <LazySymbol id="0792_archery_bow" symbol={<Symbol0792 />} />
      <LazySymbol id="0793_archery_bow" symbol={<Symbol0793 />} />
      <LazySymbol id="0794_horseshoe_luck" symbol={<Symbol0794 />} />
      <LazySymbol id="0795_canoeing_rowing_wild_river" symbol={<Symbol0795 />} />
      <LazySymbol id="0796_nature_green_sprout_plant" symbol={<Symbol0796 />} />
      <LazySymbol id="0797_flowers_plant" symbol={<Symbol0797 />} />
      <LazySymbol id="0798_leaf_tree_forest" symbol={<Symbol0798 />} />
      <LazySymbol id="0799_leaf_tree_forest" symbol={<Symbol0799 />} />
      <LazySymbol id="0800_leaf_plant_sprout_green" symbol={<Symbol0800 />} />
      <LazySymbol id="0801_shovel_ground" symbol={<Symbol0801 />} />
      <LazySymbol id="0802_plant_watering" symbol={<Symbol0802 />} />
      <LazySymbol id="0803_wheelbarrow_farming" symbol={<Symbol0803 />} />
      <LazySymbol id="0804_wheelbarrow_full" symbol={<Symbol0804 />} />
      <LazySymbol id="0805_tractor_farming" symbol={<Symbol0805 />} />
      <LazySymbol id="0806_gate_farm" symbol={<Symbol0806 />} />
      <LazySymbol id="0807_bees_honey" symbol={<Symbol0807 />} />
      <LazySymbol id="0808_bird_house_twitter" symbol={<Symbol0808 />} />
      <LazySymbol id="0809_snail_shell_house_nautilus" symbol={<Symbol0809 />} />
    </>
  );
});

Nature.displayName = 'Nature';

export default Nature;
